import { useTranslation } from 'react-i18next';

const Icon = ({ children }) => (
  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-primary/20 bg-primary/10 text-primary transition-colors duration-200 group-hover:border-primary/40 group-hover:bg-primary/15">
    {children}
  </div>
);

const ICONS = {
  rag: (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
  ),
  booking: (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <path d="m9 15 2 2 4-4" />
    </svg>
  ),
  telegram: (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="m22 2-7 20-4-9-9-4z" />
      <path d="M22 2 11 13" />
    </svg>
  ),
  fallback: (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  multilang: (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  secure: (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
};

const FEATURE_KEYS = ['rag', 'booking', 'telegram', 'fallback', 'multilang', 'secure'];

const SOON_KEYS = ['booking'];

export default function Features() {
  const { t } = useTranslation();
  return (
    <section className="border-b border-border bg-bg">
      <div className="mx-auto max-w-6xl px-4 py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold sm:text-4xl">{t('features.title')}</h2>
          <p className="mt-4 text-text-muted">{t('features.subtitle')}</p>
        </div>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURE_KEYS.map((key) => {
            const soon = SOON_KEYS.includes(key);
            return (
              <div
                key={key}
                className={`group relative overflow-hidden rounded-2xl border border-border bg-surface p-6 transition duration-200 hover:-translate-y-1 hover:border-border-strong hover:shadow-xl hover:shadow-primary/5 ${
                  soon ? 'opacity-90' : ''
                }`}
              >
                <div
                  aria-hidden
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                  style={{
                    background:
                      'radial-gradient(120% 90% at 100% 0%, color-mix(in srgb, var(--color-primary) 10%, transparent) 0%, transparent 60%)',
                  }}
                />
                {soon && (
                  <span className="absolute end-4 top-4 rounded-full border border-primary/40 bg-primary/10 px-2.5 py-0.5 text-[11px] font-medium text-primary">
                    {t('features.soon')}
                  </span>
                )}
                <div className="relative">
                  <Icon>{ICONS[key]}</Icon>
                  <h3 className="text-lg font-semibold">{t(`features.${key}.title`)}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-text-muted">{t(`features.${key}.body`)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
